
































































































































import { Geek, CollapsibleItem } from '@/models';
import { GCoinGeekHistory, GCoinTransactionType, GCoinTransactionStatus } from '@/models/gcoins';
import { buildGeekName } from '@/utils';
import { collapseMixin } from '@/shared';
import { typedStore, Actions } from '@/store';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';

export default mixins(collapseMixin).extend({
  name: 'GCoinsHistory',
  data() {
    return {
      requestStatusIconMap: {
        rejected: 'log-icon-close',
        pending: 'log-icon-pending',
        ordered: 'log-icon-pending',
        confirmed: 'log-icon-pending',
        accepted: 'log-icon-check',
      },
      loader: {
        isHistoryPending: false,
      },
    };
  },
  created() {
    this.fetchHistory();
  },
  computed: {
    collapsibleItems(): GCoinGeekHistory[] {
      return typedStore(this).state.gCoins.history;
    },
    areMoreItemsAvailable(): boolean {
      return this.collapsibleItems.length < typedStore(this).state.gCoins.pagination.totalCount
        && this.collapsibleItems.length > 0;
    },
  },
  methods: {
    async fetchHistory() {
      this.loader.isHistoryPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchGeekHistory);
      } finally {
        this.loader.isHistoryPending = false;
      }
    },
    async fetchMore() {
      this.loader.isHistoryPending = true;
      try {
        await this.$store.dispatch(Actions.gCoins.fetchMoreHistory);
      } finally {
        this.loader.isHistoryPending = false;
      }
    },
    getStatusDescription(historyElement: GCoinGeekHistory): string {
      if (historyElement.type === GCoinTransactionType.GrantedAutomatically) {
        return this.$t(
          `exchange-gcoins.history.granted-auto`,
          {
            dateTime: (this as any).$options.filters.formattedDateTime(historyElement.status.createdAt),
          },
        ) as string;
      } else if (historyElement.type === GCoinTransactionType.CustomAward
        || historyElement.type === GCoinTransactionType.Withdraw
        || historyElement.type === GCoinTransactionType.GrantedByAdmin
      ) {
        if (historyElement.status.type === GCoinTransactionStatus.Accepted) {
          return this.$t(
            `exchange-gcoins.history.accepted-by`,
            {
              geek: buildGeekName(historyElement.status.createdBy),
              dateTime: (this as any).$options.filters.formattedDateTime(historyElement.status.createdAt),
              reasonSentence: historyElement.status.reason ? this.$t(
                `exchange-gcoins.history.reason-sentence`,
                { reason: historyElement.status.reason },
              ) : '',
            },
          ) as string;
        } else if (historyElement.status.type === GCoinTransactionStatus.Rejected) {
          return this.$t(
            `exchange-gcoins.history.rejected-by`,
            {
              geek: buildGeekName(historyElement.status.createdBy),
              dateTime: (this as any).$options.filters.formattedDateTime(historyElement.status.createdAt),
              reasonSentence: historyElement.status.reason ? this.$t(
                `exchange-gcoins.history.reason-sentence`,
                { reason: historyElement.status.reason },
              ) : '',
            },
          ) as string;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    isTransactionOfIncreaseType(historyElement: GCoinGeekHistory): boolean {
      return [
        GCoinTransactionType.GrantedAutomatically,
        GCoinTransactionType.GrantedByAdmin,
      ].includes(historyElement.type);
    },
    buildGeekName,
  },
});
